<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part1">
<h1 class="left"><a id="page_13"></a><a href="#/005toc#pa1"><span class="bb"><strong>EAST TEXAS</strong> MEETS THE <strong>DEEP SOUTH</strong></span></a></h1>
<p class="noindent"><span class="aa">Texas is half South and half Southwest, with its eastern “Southern” drawl reflecting more of a honey y’all than a sassy twang. This is the land just past the Louisiana and Arkansas state lines, from Texarkana down to Dallas and continuing through Tyler and Houston, Beaumont and Galveston. This is the land of pine trees and blues music, St. Augustine grass and azaleas, swamps and gators, beauty queens and Mary Kay cosmetics, sweet tea and fried chicken, columned mansions and tin-roofed cottages, Caddo Lake up north and the Gulf down south, skyscrapers and NASA, chintz and damask, billionaires and bikers sitting side by side at a diner counter. Following is a virtual boo-fay of some of this region’s favorite sweet things.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007part1.vue?245717cc